import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { Border, Box, Padding, Text } from '../../components';
import { ExpandableQuestionView, questionsAndAnswers } from './shared';

const BackgroundWrapper = styled.div`
  background-color: #f3f6f6;
`;

export const FrequentlyAskedQuestionsTablet = () => {
  return (
    <BackgroundWrapper>
      <Box
        ratio={0.5}
        backgroundImage="images/frequently-asked-questions-picture.jpg"
      />

      <Padding size={[7]}>
        <Padding size={[0, 0, 7, 0]}>
          <Text textType="heading3" align="left">
            Frequently Asked Questions
          </Text>
        </Padding>
        <Border borderSize={[1, 0, 0, 0]} borderRole="grey3">
          {_.flow((questionsAndAnswers) =>
            _.map(questionsAndAnswers, (singleValue, index) => {
              return (
                <ExpandableQuestionView
                  questionAndAnswer={singleValue}
                  key={index}
                />
              );
            })
          )(questionsAndAnswers)}
        </Border>
      </Padding>
    </BackgroundWrapper>
  );
};
